module.exports = __webpack_public_path__ + "img/PPMP30.4488d3dc.png";